import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { EnrollmentAcceptedStudentService } from 'src/app/service/enrollmentAcceptedStudent.service';
import { EnrollmentGroupService } from 'src/app/service/enrollment-group.service';
import { AttendanceService } from 'src/app/service/attendance.service';
import { CoursesService } from 'src/app/service/courses.service';

declare var $: any;

@Component({
  selector: 'app-available-dates',
  templateUrl: './available-dates.component.html',
  styleUrls: ['./available-dates.component.scss']
})
export class AvailableDatesComponent implements OnInit {

  yearId:any;
  semesterId:any;
  batchId:any;
  select: any;
  showLoader: boolean = false;
  searchFlag: boolean = false;
  loadAvailableDateEdit: boolean = false;
  availableDates: any = [];
  
  repeaterPage: boolean = false;
  searchByFields: any;
  table: any;
  years: any;
  semesters: any;
  batches: any;
  orgId: any;
  username: any;

  currentYear: any;
  currentSemester: any;
  currentBatch: any;
  currentStatus: any;
  currentGroup: any;
  currentLang: any;
  updateRecord:any;

  currentAvailableDateId: any;

  groups: any = [];
  batchGroups:any=[];
  courses: any = [];

  searchForm = new FormGroup({
    year: new FormControl('', [
      Validators.required,
    ]),
    semester: new FormControl('', [
      Validators.required,
    ]),
    batch: new FormControl('', [
      Validators.required,
    ])
    ,
    group: new FormControl('', [
      Validators.required,
    ])
  });

  updateAvailableDatePopup = new FormGroup({
    datetimeFrom: new FormControl('', [
      Validators.required,
    ]),
    datetimeTo: new FormControl('', [
      Validators.required,
    ]),
    status: new FormControl('', [
      // Validators.required,
    ]),
    remarks: new FormControl('', [
      // Validators.required,
    ])
  });

  constructor(private coursesService: CoursesService,private toastrService: ToastrService, public enrollmentAcceptedStudentService: EnrollmentAcceptedStudentService, public globals: Globals, public translate: TranslateService, private enrollmentGroupService: EnrollmentGroupService, private attendance: AttendanceService
    ) { }

  ngOnInit(): void {
    this.orgId = this.globals.currentUserInfo.orgid;
    this.username = this.globals.currentUserInfo.username;
    this.currentLang = this.globals.lang;
    this.getYears();

    this.translate.onLangChange.subscribe(() => {
      this.updateTable();
      
    });
  }

  updateTable() {
    if (this.table) {
      this.table.destroy();
    } else { $("#datatable").DataTable().destroy(); }

    setTimeout(() => {
      this.table = $("#datatable").DataTable({
        // columnDefs: [{
        //   orderable: false,
        //   className: 'select-checkbox',
        //   targets: 0
        // }],
        // select: {
        //   style: 'multi',
        //   selector: 'td:first-child',
        //   blurable: false
        // },
        // select: true,
        dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        // responsive: true,
        // columnDefs: [
        //   { responsivePriority: 1, targets: 0 },
        //   { responsivePriority: 10001, targets: 4 },
        //   { responsivePriority: 2, targets: -2 }
        // ],
        // rowReorder: true,
        // "columnDefs": [
        //   { orderable: true, className: 'reorder', targets: [0] },
        //   { orderable: false, targets: '_all' }
        // ],
        // pageLength: 5,
        paging: false,
        searching: true,
        ordering: true,
        lengthChange: false,
        info: true,
        search: {
          searchPlaceholder: "Search",
        },
        language: {
          search: "",
          searchPlaceholder: "Search",
        },
        buttons: [{
          extend: 'excelHtml5',
          text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
          titleAttr: 'EXCEL',
          exportOptions: {
            columns: [0, 1, 2]
          },
          className: 'datatable_custom_buttons',
        }],
      })
    }, 1);

  }

  searchFormChange() {
  }

  searchFormSubmit() {
    if (this.searchForm.valid) {
      this.currentYear = this.searchForm.controls.year.value;
      this.currentSemester = this.searchForm.controls.semester.value;
      this.currentBatch = this.searchForm.controls.batch.value;
     // this.currentGroup = this.searchForm.controls.group.value;

      // Reset popup values
      this.updateAvailableDatePopup.reset();
      this.currentAvailableDateId = 0;

      this.getAvailableDates();
      this.searchFlag=true;
      

    } else {
      this.searchForm.markAllAsTouched();
      this.searchForm.markAsDirty();
      this.searchFlag=false;
    }
  }

  getYears() {
    this.enrollmentGroupService.getYears()
      .subscribe(
        data => {
          this.years = data;
          this.getAllCourses();

        },
        () => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

  getYearSemesters() {
    let year = this.searchForm.controls.year.value;
    if (year) {
      this.enrollmentGroupService.getYearSemesters(year)
        .subscribe(
          data => {
            this.semesters = data;
          },
          () => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.searchForm.controls.semester.reset();
      this.semesters = [];
    }
  }

  getBatches() {
    let year = this.searchForm.controls.year.value;
    let semester = this.searchForm.controls.semester.value;
    if (year && semester) {
      this.enrollmentGroupService.getSemesterBatches(this.orgId, year, semester)
        .subscribe(
          data => {
            this.batches = data;
          },
          () => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.searchForm.controls.batch.reset();
      this.batches = [];
    }
  }

  getBatchGroups() {
    let batch = this.searchForm.controls.batch.value;
    if (batch) {
      this.attendance.getBatchGroups(this.orgId, batch)
        .subscribe(
          data => {
            this.batchGroups = data;
          },
          () => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.searchForm.controls.group.reset();
      this.groups = [];
    }
  }
  getAllCourses() {
    // this.showLoader = true;
    this.coursesService.getAllCourses()
      .subscribe(
        data => {
          this.courses = data;
          this.getGroups();
        }
      );
  }

    getGroups() {
    this.enrollmentGroupService.getAllGroups()
      .subscribe(
        data => {
          this.groups = data;
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }
  getAvailableDates() {
    this.showLoader = true;
    this.yearId = this.searchForm.controls.year.value;
    this.semesterId = this.searchForm.controls.semester.value;
    this.batchId = this.searchForm.controls.batch.value;
    let group =this.searchForm.controls.group.value;

    this.attendance.getDateStatusByYearSemesterBatchGroup(this.orgId,this.yearId, this.semesterId,this.batchId,group)
      .subscribe(
        data => {
          data = data.map((element: any) => {
            let course = this.courses.filter((i: any) => i.id == element.subjectid)[0];
            let group = this.groups.filter((i: any) => i.id == element.groupid)[0];
            return { ...element, group, course};
          });
          this.availableDates = data;
          this.showLoader = false;
          this.updateTable();
        },
        () => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          this.showLoader = false;
        }
      );
  }

  updateAvailableDate(){
    if (this.updateAvailableDatePopup.valid) {
      this.updateRecord.schTimeFrom=this.updateAvailableDatePopup.controls.datetimeFrom.value;
      this.updateRecord.schTimeTo=this.updateAvailableDatePopup.controls.datetimeTo.value;
      this.updateRecord.remarks=this.updateAvailableDatePopup.controls.remarks.value;
      let username=this.globals.currentUserInfo.username;
      this.attendance.UpdateDateShById(username,this.updateRecord.id,this.updateRecord)
      .subscribe(
        data => {
          if (data.sts == "SUCCESS") {
          if (this.globals.lang == "ar") {
            this.toastrService.success(data.arMsg);
          } else {
            this.toastrService.success(data.enMsg);
          }
          this.getAvailableDates();
        }else{
          if (this.globals.lang == "ar") {
            this.toastrService.error(data.arMsg);
          } else {
            this.toastrService.error(data.enMsg);
          }
        }
        },
        () => {
          this.toastrService.error(this.translate.instant('FAIL_TO_UPDATE'));
        }
      );


      console.log(this.updateAvailableDatePopup.value);
      this.updateAvailableDatePopup.reset();
      this.currentAvailableDateId = 0;
      $('#close-available-date-popup').click();
    } else {
      this.updateAvailableDatePopup.markAllAsTouched();
      this.updateAvailableDatePopup.markAsDirty();
    }
  }

  updateCurrentAvailableDate(id: any){
    this.currentAvailableDateId = id;
  }

  getDateById(id: any){
    this.loadAvailableDateEdit = true;
    this.attendance.getDateShById(id)
      .subscribe(
        data => {
          console.log('call get available date API for (' + id +')');
          this.updateRecord=data;
          this.updateAvailableDatePopup.controls.datetimeFrom.setValue(new Date(data.schTimeFrom).toISOString().substring(0, 16));
          this.updateAvailableDatePopup.controls.datetimeTo.setValue(new Date(data.schTimeTo).toISOString().substring(0, 16));
          this.updateAvailableDatePopup.controls.status.setValue(data.statusFlag);
          this.updateAvailableDatePopup.controls.remarks.setValue(data.remarks);
          this.loadAvailableDateEdit = false;
        },
        () => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          this.loadAvailableDateEdit = false;
        }
      );
    
    
  }

  cancelAvailableDate(){
    console.log('call cancel available date API for (' + this.currentAvailableDateId +')');
  }

  deleteAvailableDate(){
    console.log('call delete available date API for (' + this.currentAvailableDateId +')');
    let username=this.globals.currentUserInfo.username;
    this.attendance.DeleteDateShById(username,this.currentAvailableDateId)
    .subscribe(
      data => {
        if (data.sts == "SUCCESS") {
          if (this.globals.lang == "ar") {
            this.toastrService.success(data.arMsg);
          } else {
            this.toastrService.success(data.enMsg);
          }
          this.getAvailableDates();
        }else{
          if (this.globals.lang == "ar") {
            this.toastrService.error(data.arMsg);
          } else {
            this.toastrService.error(data.enMsg);
          }
        }
      },
      () => {
        this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        this.loadAvailableDateEdit = false;
      }
    );
  
  }

}

